import React, {CSSProperties} from "react"
import {rem} from "../utils/CSSUtils";
import {ReactProps} from "../constants/Props";

export interface Props extends ReactProps {
    size: number,
    center?: boolean,
    color?: string,
    fontWeight?: number
}

export default (props: Props) => {
    const {size, color, center = true, children, fontWeight} = props;

    const style:CSSProperties = {
        fontSize: rem(size),
        whiteSpace: 'pre-wrap'
    };

    if (color) {
        style.color = color;
    }

    if (center) {
        style.textAlign = 'center';
    }

    if (fontWeight) {
        style.fontWeight = fontWeight;
    }

    return (
        <span style={style}>
            {children}
        </span>
    );
}
